import { useState, useMemo } from "react";
import {
    Grid,
    Container,
    Paper,
    CircularProgress,
    Alert,
    Box,
    Typography,
    Card,
    CardContent,
    Button,
    Modal,
    TextField,
    InputAdornment,
    Autocomplete,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,


} from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import { useGetMutual } from "../../Services/MutualPaciente";
import { modalStyle, inputFecha, buttonGuardar, buttonCancelar, Titulo, TituloPrincipal, InputBuscador, Input, Texto, SubTitulodos } from "../../Layouts/CustomStyles";
import { DataGrid } from "@mui/x-data-grid";
import { DiseñoDataGrid } from "../../Components/FuncionesGenerales/DataGrid";
import Logocolor from "../../Image/Logo.png";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { useDeudoresCBO } from "../../Services/Deudores";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useGetDeudores } from "../../Hook/CBO/Deudores";
import { useIngresoPaciente } from "../../Services/IngresoPaciente";
import { FormatRut } from "../../Components/FuncionesGenerales/Rut";
import { formatCLP } from "../../Components/FuncionesGenerales/FormatoCLP";
import { useGetPrestacionServicio } from "../../Services/MutualPaciente";
import SearchIcon from "@mui/icons-material/Search";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { PiMicrosoftExcelLogoBold } from "react-icons/pi";
import { useMutualMesesAnteriores } from "../../Hook/CBO/Mutual";
import { useMutualEstados } from "../../Hook/CBO/Mutual";

export const PaginaPrestaciondeServicio = () => {
    const {
        mutual,
        errorMutual,
        loadingMutual,
        refetchMutual: fetchGetMutual,
    } = useGetMutual();

    const { Prestacion,
        loadingPrestacion,
        refetchPrestacion: fetchGetPrestacionGeneral, } = useGetPrestacionServicio();

    const { PrestacionAnterior,
        refetchPrestacionAnterior: fetchGetPrestacionGeneralAnterior } = useMutualMesesAnteriores();

    const { mutualEstado,
        refetchMutualEstado: fetchGetMutualEstado } = useMutualEstados();

    const { refetchDeudores: fetchGetDeudores } = useGetDeudores();
    const { editarIngresoPaciente } = useIngresoPaciente();
    const { CambioPacientePagado } = useDeudoresCBO();
    const [selectedRow, setSelectedRow] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [fechaPago, setFechaPago] = useState("");
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [selectedIngreso, setSelectedIngreso] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [openPrestacion, setOpenPrestacion] = useState(false);
    // Estados de búsqueda y filtros
    const [busqueda, setBusqueda] = useState("");
    const [mesSeleccionado, setMesSeleccionado] = useState("");
    const [anioSeleccionado, setAnioSeleccionado] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [mesSeleccionadodialog, setMesSeleccionadodialog] = useState("");
    const [anioSeleccionadodialog, setAnioSeleccionadodialog] = useState("");
    const [episodio, setEpisodio] = useState("")
    const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");

    const sucursales = useMemo(() => {
        const map = new Map();
        mutual.forEach(item => {
            if (item.branch) {
                map.set(item.branch.id, item.branch);
            }
        });
        return Array.from(map.values());
    }, [mutual]);



    const columnasPrestacion = [
        { field: "fecha_pago", headerName: "Fecha Pago", width: 130 },
        { field: "episodio", headerName: "Episodio", width: 150 },
        { field: "nombre_paciente", headerName: "Paciente", width: 200 },
        { field: "prevision", headerName: "Previsión", width: 150 },
        { field: "rut", headerName: "RUT", width: 150, renderCell: (params) => FormatRut(params.value) },
        { field: "monto", headerName: "Monto", width: 130, renderCell: (params) => formatCLP(params.value) },
        { field: "estado_pago", headerName: "Estado Pago", width: 150 },
    ];



    const filtrarDatos = (lista) => {
        return lista.filter((item) => {
            // 🔎 FILTRO EPISODIO / TEXTO
            const coincideBusqueda =
                !episodio ||
                item?.episodio?.toString().includes(episodio) ||
                item?.nombre_paciente?.toLowerCase().includes(episodio.toLowerCase()) ||
                item?.rut?.toString().includes(episodio);

            // 📅 FILTRO FECHA
            const fecha = new Date(item.fecha_pago);
            const mes = fecha.getMonth() + 1;
            const anio = fecha.getFullYear();

            const coincideMes = !mesSeleccionado || mes === Number(mesSeleccionado);
            const coincideAnio = !anioSeleccionado || anio === Number(anioSeleccionado);

            return coincideBusqueda && coincideMes && coincideAnio;
        });
    };


    const pagadosFiltrados = useMemo(() => {
        return filtrarDatos(mutualEstado?.pagados ?? []);
    }, [mutualEstado?.pagados, episodio, mesSeleccionado, anioSeleccionado]);

    const noPagadosFiltrados = useMemo(() => {
        return filtrarDatos(mutualEstado?.no_pagados ?? []);
    }, [mutualEstado?.no_pagados, episodio, mesSeleccionado, anioSeleccionado]);


    const handleDescargarExcel = () => {
        try {
            // Crear workbook
            const wb = XLSX.utils.book_new();

            // Datos
            const dataPagados = pagadosFiltrados?.map(item => ({
                Fecha: item.fecha_pago,
                Episodio: item.episodio,
                Paciente: item.nombre_paciente,
                Previsión: item.prevision,
                RUT: item.rut,
                Monto: formatCLP(item.monto),
                "Estado Pago": item.estado_pago,
            }));

            const dataNoPagados = noPagadosFiltrados?.map(item => ({
                Fecha: item.fecha_pago,
                Episodio: item.episodio,
                Paciente: item.nombre_paciente,
                Previsión: item.prevision,
                RUT: item.rut,
                Monto: formatCLP(item.monto),
                "Estado Pago": item.estado_pago,
            }));

            // Convertir a hoja
            const wsPagados = XLSX.utils.json_to_sheet(dataPagados);
            const wsNoPagados = XLSX.utils.json_to_sheet(dataNoPagados);

            // Agregar hojas al libro
            XLSX.utils.book_append_sheet(wb, wsPagados, "Pagados");
            XLSX.utils.book_append_sheet(wb, wsNoPagados, "No Pagados");

            // Exportar archivo
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            saveAs(
                new Blob([excelBuffer], { type: "application/octet-stream" }),
                `Prestaciones_${mesSeleccionado}_${anioSeleccionado}.xlsx`
            );

        } catch (error) {
            console.error("Error exportando Excel:", error);
        }
    };

    const handleBuscarPrestacion = async () => {
        await fetchGetMutualEstado({
            mes: mesSeleccionado || undefined,
            anio: anioSeleccionado || undefined,
        });
    };


    // Extrae meses y años únicos
    const meses = [
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" },
    ];
  
    const anios = useMemo(() => {
        const lista = mutual.map((item) => new Date(item.fecha).getFullYear());
        return [...new Set(lista)].sort((a, b) => b - a);
    }, [mutual]);

  

    // Opciones únicas del Autocomplete
    const opcionesUnicas = useMemo(() => {
        const mapa = new Map();
        mutual.forEach((f) => {
            const key = `${f.nombre_paciente}-${f.rut}`;
            if (!mapa.has(key)) {
                mapa.set(key, { nombre_paciente: f.nombre_paciente, rut: f.rut });
            }
        });
        return Array.from(mapa.values());
    }, [mutual]);

    // 🔹 Filtrado general
    const datosFiltrados = useMemo(() => {
        return mutual.filter((item) => {
            const coincideBusqueda =
                !busqueda ||
                item.nombre_paciente.toLowerCase().includes(busqueda.toLowerCase()) ||
                item.rut.toLowerCase().includes(busqueda.toLowerCase());

            const fecha = new Date(item.fecha_pago);
            const mes = fecha.getMonth() + 1;
            const anio = fecha.getFullYear();

            const coincideMes = !mesSeleccionado || mes === parseInt(mesSeleccionado);
            const coincideAnio = !anioSeleccionado || anio === parseInt(anioSeleccionado);

            const coincideSucursal =
                !sucursalSeleccionada ||
                item.branch?.id === parseInt(sucursalSeleccionada);

            return (
                coincideBusqueda &&
                coincideMes &&
                coincideAnio &&
                coincideSucursal
            );
        });
    }, [mutual, busqueda, mesSeleccionado, anioSeleccionado, sucursalSeleccionada]);



    const totalPacientesUltimoMes = Prestacion?.totales_generales?.pacientes_total || 0;

    const totalMontoUltimoMes = formatCLP(
        Number(Prestacion?.totales_generales?.monto_total || 0)
    );



    const prestacionesArrayUltimoMes = Prestacion?.resumen_por_sucursal_prestacion?.map(item => ({
        nombre: item.prevision,
        sucursal: item.sucursal,
        pacientes: Number(item.total_pacientes),
        totalMonto: Number(item.total_monto)
    })) || [];




    const handleCloseEdit = () => {
        setOpenEdit(false);
        setSelectedIngreso(null);
    };

    const handleClosePrestacion = () => {
        setOpenPrestacion(false);
    };

    const handleOpenPrestacion = (row) => {
        setOpenPrestacion(true);
    };
    const handleEditarIngreso = async () => {
        if (!selectedIngreso) return;

        try {
            setEnviandoAlert(true);

            const payload = {
                fecha: selectedIngreso.fecha,
                fecha_pago: selectedIngreso.fecha_pago,
                rut: selectedIngreso.rut,
                estado_pago: selectedIngreso.estado_pago,
                nombre_paciente: selectedIngreso.nombre_paciente,
                estado_paciente: selectedIngreso.estado_paciente,
                prevision: selectedIngreso.prevision,
                medico_tratante: selectedIngreso.medico_tratante,
                branch_id: selectedIngreso.branch_id,
                kine: selectedIngreso.kine,
                n_sesiones: selectedIngreso.n_sesiones,
                episodio: selectedIngreso.episodio,
                monto: selectedIngreso.monto,
                valor: selectedIngreso.monto,
                observaciones: selectedIngreso.observaciones,
            };


            await editarIngresoPaciente(selectedIngreso.id, payload);

            setAlertMessage("Ingreso actualizado correctamente ✅");
            setSuccessAlertOpen(true);
            fetchGetMutual(); // recarga la lista
            handleCloseEdit(); // cierra el modal
        } catch (error) {
            setAlertMessage(`Error al actualizar: ${error}`);
            setErrorAlertOpen(true);
        } finally {
            setEnviandoAlert(false);
        }
    };



    const handleCambiarPago = async () => {
        if (!fechaPago) {
            setAlertMessage("Selecciona una fecha de pago");
            setErrorAlertOpen(true);
            return;
        }
        setEnviandoAlert(true);
        try {
            await CambioPacientePagado(selectedRow.id, fechaPago, episodio);
            setAlertMessage("Paciente marcado como pagado ✅");
            setSuccessAlertOpen(true);
            fetchGetDeudores(); // refresca tabla
            setDialogOpen(false);
            setFechaPago("");
        } catch (error) {
            setAlertMessage(error || "Error al marcar como pagado ❌");
            setErrorAlertOpen(true);
        } finally {
            setEnviandoAlert(false);
        }
    };

    const columns = [
        {
            field: "nombre_paciente",
            headerName: "Nombre Paciente",
            flex: 1,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        sx={{ textTransform: 'capitalize', fontFamily: 'Poppins' }}
                    >
                        {params.row.nombre_paciente}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13, fontFamily: 'Poppins' }}>
                        {params.row.rut || "-"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13, fontFamily: 'Poppins' }}>
                        {params.row.branch.name || "-"}
                    </Typography>

                </Box>
            ),
        },
        {
            field: "prevision", headerName: "Prevision de servicio", flex: 1
        },
        {
            field: "monto",
            headerName: "Monto ($)",
            flex: 1,
            renderCell: (params) =>
                new Intl.NumberFormat("es-CL", {
                    style: "currency",
                    currency: "CLP",
                    minimumFractionDigits: 0,
                }).format(params.row.monto || 0),
        },

        {
            field: "fecha_pago",
            headerName: "Fecha de Pago",
            sortable: true,
            flex: 1,
            renderCell: (params) => {
                const fecha = new Date(params.row.fecha_pago);
                const dia = fecha.getUTCDate();
                const mes = fecha.getUTCMonth() + 1;
                const anio = fecha.getUTCFullYear();
                return `${dia.toString().padStart(2, '0')}-${mes.toString().padStart(2, '0')}-${anio}`;
            }
        },
        {
            field: "acciones",
            headerName: "Acciones",
            flex: 1,
            renderCell: (params) => {


                const handleOpenDialog = () => {
                    setSelectedRow(params.row);
                    setDialogOpen(true);
                };

                return (
                    <Button
                        variant="contained"
                        size="small"
                        sx={{
                            fontFamily: "Poppins",
                            backgroundColor: "#4CAF50",
                            textTransform: "capitalize",
                            "&:hover": { backgroundColor: "#3e8e41" },
                        }}
                        onClick={handleOpenDialog}

                    >
                        Marcar como Pagado
                    </Button>
                );
            },
        },

        {
            field: "",
            headerName: "editar",
            width: 150,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            gap: 1,
                            width: 150,
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <button className="edit-button" onClick={() => handleOpenEdit(params.row)}>
                            <svg className="edit-svgIcon" viewBox="0 0 512 512">
                                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                            </svg>
                        </button>
                    </Box>
                );
            },
        },

    ];

    const handleOpenEdit = (row) => {
        setSelectedIngreso(row);
        setOpenEdit(true);
    };

    const resumenPorSucursal = useMemo(() => {
        const acc = {};

        const data = Prestacion?.resumen_por_sucursal_prestacion || [];

        data.forEach(item => {
            const sucursal = item.sucursal || "Sin sucursal";

            if (!acc[sucursal]) {
                acc[sucursal] = {
                    sucursal,
                    totalMonto: 0,
                    pacientes: 0,
                };
            }

            acc[sucursal].totalMonto += Number(item.total_monto || 0);
            acc[sucursal].pacientes += Number(item.total_pacientes || 0);
        });

        return Object.values(acc);
    }, [Prestacion]);



    const resumenMesSucursal = useMemo(() => {
        const data = PrestacionAnterior?.resumen_por_sucursal_prestacion || [];

        const acc = {};

        data.forEach(item => {
            const sucursal = item.sucursal || "Sin sucursal";

            if (!acc[sucursal]) {
                acc[sucursal] = {
                    sucursal,
                    totalMonto: 0,
                    pacientes: 0
                };
            }

            acc[sucursal].totalMonto += Number(item.total_monto || 0);
            acc[sucursal].pacientes += Number(item.total_pacientes || 0);
        });

        return Object.values(acc);
    }, [PrestacionAnterior]);


    const totalMes = formatCLP(
        Number(PrestacionAnterior?.totales_generales?.monto_total || 0)
    );

    return (
        <Container maxWidth='xl'>
            <Paper
                elevation={3}
                sx={{
                    p: 3,
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    minHeight: "70vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box display="flex" alignItems="center" gap={2} mb={6}>
                    <img
                        src={Logocolor}
                        alt="Logo Clínica Activa"
                        style={{ width: 55, height: 55, objectFit: "contain" }}
                    />
                    <Typography variant="h5" sx={TituloPrincipal}>
                        Prestaciones de Servicios Cubiertas por Mutual
                    </Typography>
                </Box>
                <Box mb={4}>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#2a8d74",
                            color: "white",
                            borderRadius: "30px",
                            textTransform: "none",
                            fontFamily: "Poppins",
                            px: 3,
                            py: 1.2,
                            "&:hover": { backgroundColor: "#256f5e" },
                        }}
                        onClick={handleOpenPrestacion}> Reporte  Prestación de servicios</Button>
                </Box>
                <Box   >
                    <Typography variant="h5" sx={{ ...TituloPrincipal, mt: 2, mb: 2 }}>
                        Registro total del mes prestación de servicios
                    </Typography>

                    <Grid container spacing={2} mb={4}>
                        <Grid size={{ xs: 12, md: 6 }}>

                            <Card sx={{
                                flex: 1,
                                backgroundColor: "#ffffff", // blanco limpio
                                borderRadius: 3,            // bordes redondeados
                                boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)", // sombreado sutil
                                transition: "transform 0.2s, box-shadow 0.2s",

                            }}>
                                <CardContent gap={1} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                                    <Box display="flex" alignItems="center" justifyContent="center" gap={1} sx={{ width: '80%', flexDirection: 'column' }}>

                                        <Typography variant="h4" mt={1} sx={{
                                            color: '#2a8d74',
                                            fontFamily: 'Poppins',
                                            fontWeight: '500 '
                                        }}> {totalPacientesUltimoMes}</Typography>
                                        <Typography variant="h6" sx={{
                                            mb: 2,
                                            color: '#585857',
                                            fontFamily: 'Poppins',
                                            fontWeight: '500 '
                                        }}>Pacientes</Typography>

                                    </Box>
                                    <Box sx={{ width: '20%' }}>
                                        <PeopleOutlineIcon sx={{ color: '#5cd09aff', fontSize: '4rem' }} />
                                    </Box>

                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            {/* Card 2: Total monto */}
                            <Card sx={{
                                flex: 1,
                                backgroundColor: "#ffffff", // blanco limpio
                                borderRadius: 3,            // bordes redondeados
                                boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)", // sombreado sutil
                                transition: "transform 0.2s, box-shadow 0.2s",

                            }}>
                                <CardContent gap={1} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                                    <Box sx={{ width: '80%', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography variant="h4" mt={1} sx={{
                                            color: '#2a8d74',
                                            fontFamily: 'Poppins',
                                            fontWeight: '500 '
                                        }}>
                                            {totalMontoUltimoMes}
                                        </Typography>
                                        <Typography variant="h6" sx={{
                                            color: '#585857',
                                            fontFamily: 'Poppins',
                                            fontWeight: '500 ',
                                            mb: 2,
                                        }}>Monto Total </Typography>

                                    </Box>


                                    <Box sx={{ width: '20%' }}>
                                        <AttachMoneyIcon sx={{ color: '#5cd09aff', fontSize: '4rem' }} />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        {prestacionesArrayUltimoMes.map((p) => (
                            <Grid size={{ xs: 12, md: 6, lg: 3 }}>

                                <Card sx={{
                                    flex: 1,
                                    backgroundColor: "#ffffff", // blanco limpio
                                    borderRadius: 3,            // bordes redondeados
                                    boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)", // sombreado sutil
                                    transition: "transform 0.2s, box-shadow 0.2s",

                                }}>
                                    <CardContent gap={1} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                                        <Box sx={{ width: '80%', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <Typography variant="h4" mt={1} sx={{
                                                color: '#2a8d74',
                                                fontFamily: 'Poppins',
                                                fontWeight: '500 '
                                            }}>
                                                {new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(p.totalMonto)}
                                            </Typography>
                                            <Typography variant="h6" sx={{
                                                color: '#585857',
                                                fontFamily: 'Poppins',
                                                fontWeight: '500 ',

                                            }}>Monto Total {p.nombre}</Typography>

                                            <Typography variant="h6" sx={{
                                                color: '#585857',
                                                fontFamily: 'Poppins',
                                                fontWeight: '500 ',
                                                mb: 2,
                                            }}>{p.sucursal}</Typography>
                                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                                                <Box >
                                                    <Typography sx={{ fontSize: '1rem', fontWeight: '500', color: '#2a8d74', fontFamily: 'Poppins' }}>
                                                        Pacientes: {p.pacientes}
                                                    </Typography></Box>


                                            </Box>


                                        </Box>


                                        <Box sx={{ width: '20%' }}>
                                            <AttachMoneyIcon sx={{ color: '#5cd09aff', fontSize: '4rem' }} />
                                        </Box>
                                    </CardContent>
                                </Card>

                            </Grid>
                        ))}
                        {resumenPorSucursal.map((s) => (
                            <Grid size={{ xs: 12, md: 4 }} key={s.sucursal}>
                                <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                                    <CardContent sx={{ textAlign: "center" }}>
                                        <Typography variant="h6" sx={{ fontFamily: "Poppins", color: '#585857' }}>
                                            {s.sucursal}
                                        </Typography>

                                        <Typography variant="h4" color="primary" sx={{ fontFamily: "Poppins" }}>
                                            {formatCLP(s.totalMonto)}
                                        </Typography>

                                        <Typography sx={{ fontFamily: "Poppins", fontWeight: 500, color: '#585857' }}>
                                            Pacientes: {s.pacientes}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}

                    </Grid>





                </Box>


                <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                    <Button
                        variant="contained"
                        onClick={() => setOpenDialog(true)}
                        sx={{
                            backgroundColor: "#2a8d74",
                            color: "white",
                            borderRadius: "30px",
                            textTransform: "none",
                            fontFamily: "Poppins",
                            px: 3,
                            py: 1.2,
                            "&:hover": { backgroundColor: "#256f5e" },
                        }}
                    >
                        ¿Quieres ver reporte financiero meses anteriores?
                    </Button>
                </Box>

                <Box sx={{ mt: 2, mb: 3 }}>
                    {PrestacionAnterior && (
                        <Box>
                            <Card sx={{ borderRadius: 3, p: 3, mt: 3, boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)" }}>
                                <CardContent>

                                    <Typography variant="h5" sx={TituloPrincipal}>
                                        Registro total del mes {PrestacionAnterior?.mes} / {PrestacionAnterior?.anio}
                                    </Typography>

                                    <Typography sx={{ color: "#555", fontFamily: "Poppins", mb: 2 }}>
                                        Resumen financiero del mes seleccionado
                                    </Typography>

                                    <Divider sx={{ my: 2 }} />

                                    <Typography
                                        variant="h3"
                                        sx={{ fontFamily: "Poppins", fontWeight: 700, color: "#2a8d74" }}
                                    >
                                        {totalMes}
                                    </Typography>

                                    <Typography sx={{ color: "#777", fontFamily: "Poppins", mt: 1 }}>
                                        Total facturado a prestadores de servicio (Aseguradora)
                                    </Typography>

                                </CardContent>
                            </Card>
                            <Box>

                                <Grid container spacing={2}>
                                    {resumenMesSucursal.map((s) => (
                                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={s.sucursal}>
                                            <Card
                                                sx={{
                                                    mt: 3,
                                                    borderRadius: 3,
                                                    boxShadow: "0px 3px 8px rgba(42, 103, 69, 0.25)",
                                                    backgroundColor: "#f9fdfb",
                                                }}
                                            >
                                                <CardContent sx={{ textAlign: "center" }}>
                                                    <Typography
                                                        variant="h6"
                                                        sx={{
                                                            fontFamily: "Poppins",
                                                            fontWeight: 600,
                                                            color: "#182f53",
                                                        }}
                                                    >
                                                        {s.sucursal}
                                                    </Typography>

                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            fontFamily: "Poppins",
                                                            fontWeight: 700,
                                                            color: "#2a8d74",
                                                            mt: 1,
                                                        }}
                                                    >
                                                        {new Intl.NumberFormat("es-CL", {
                                                            style: "currency",
                                                            currency: "CLP",
                                                            minimumFractionDigits: 0,
                                                        }).format(s.totalMonto)}
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontFamily: "Poppins",
                                                            color: "#555",
                                                            mt: 1,
                                                        }}
                                                    >
                                                        Pacientes: <b>{s.pacientes}</b>
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>

                            </Box>
                        </Box>

                    )}
                </Box>

                <Typography variant="h5" sx={{ ...TituloPrincipal, mt: 2, mb: 2 }}>
                    Usuarios pendientes de registro en SAP
                </Typography>
                {loadingMutual ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                        }}
                    >
                        <CircularProgress size={60} thickness={4} />
                    </Box>
                ) : errorMutual ? (
                    <Alert severity="error">
                        Error al cargar los pacientes Mutual: {errorMutual}
                    </Alert>
                ) : mutual.length === 0 ? (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                            color: "#666",
                            textAlign: "center",
                        }}
                    >
                        <SentimentSatisfiedAltIcon sx={{ fontSize: 60, mb: 1 }} />
                        <Typography variant="h6" sx={{ fontFamily: "Poppins" }}>
                            ¡Actualmente no existe pendientes de registro!
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ position: 'relative' }}>

                        <Box
                            sx={{
                                position: "absolute",
                                zIndex: 1,
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 2,
                                alignItems: "center",
                                mb: 2,
                            }}
                        >
                            {/* 🔍 Autocomplete Nombre/RUT */}
                            <Autocomplete
                                freeSolo
                                options={opcionesUnicas.map((f) => `${f.nombre_paciente} (${f.rut})`)}
                                onChange={(e, value) => {
                                    if (value) {

                                        const match = value.match(/\(([^)]+)\)$/);
                                        if (match) {
                                            setBusqueda(match[1]);
                                        } else {
                                            setBusqueda(value);
                                        }
                                    } else {
                                        setBusqueda("");
                                    }
                                }}
                                onInputChange={(e, value) => {

                                    setBusqueda(value);
                                }}
                                sx={{
                                    width: 350,
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "30px",
                                        fontFamily: "Poppins",
                                        "& fieldset": { borderColor: "#C5C5C5" },
                                        "&:hover fieldset": { borderColor: "#4C96AF" },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#4C96AF",
                                            boxShadow: "0 0 0 2px rgba(76,150,175,0.2)",
                                        },
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Buscar por nombre o RUT"
                                        variant="outlined"
                                        InputLabelProps={{ style: { fontFamily: "Poppins" } }}
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontFamily: "Poppins", fontSize: 14 },
                                        }}
                                    />
                                )}
                            />
                            <FormControl sx={{ ...InputBuscador, width: 200 }}>
                                <InputLabel sx={{ fontFamily: "Poppins" }}>Sucursal</InputLabel>
                                <Select
                                    value={sucursalSeleccionada}
                                    label="Sucursal"
                                    onChange={(e) => setSucursalSeleccionada(e.target.value)}
                                    sx={{ fontFamily: "Poppins" }}
                                >
                                    <MenuItem value="">Todas</MenuItem>
                                    {sucursales.map((s) => (
                                        <MenuItem key={s.id} value={s.id}>
                                            {s.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>



                            <FormControl sx={{ ...InputBuscador, width: 160 }}>
                                <InputLabel sx={{ fontFamily: "Poppins" }}>Mes</InputLabel>
                                <Select
                                    value={mesSeleccionado}
                                    label="Mes"
                                    onChange={(e) => setMesSeleccionado(e.target.value)}
                                    sx={{ fontFamily: "Poppins" }}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {meses.map((m) => (
                                        <MenuItem key={m.value} value={m.value}>
                                            {m.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>


                            <FormControl sx={{ ...InputBuscador, width: 120 }}>
                                <InputLabel sx={{ fontFamily: "Poppins" }}>Año</InputLabel>
                                <Select
                                    value={anioSeleccionado}
                                    label="Año"
                                    onChange={(e) => setAnioSeleccionado(e.target.value)}
                                    sx={{ fontFamily: "Poppins" }}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {anios.map((a) => (
                                        <MenuItem key={a} value={a}>
                                            {a}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>


                        <Box sx={{ flexGrow: 1 }}>
                            <DataGrid
                                rows={datosFiltrados.map((item, index) => ({
                                    id: index,
                                    ...item,
                                }))}
                                showToolbar
                                columns={columns}
                                pageSize={10}
                                rowsPerPageOptions={[10, 25, 50]}
                                disableSelectionOnClick
                                autoHeight
                                rowHeight={80}
                                initialState={{
                                    pagination: { paginationModel: { pageSize: 10, page: 0 } },
                                    sorting: {
                                        sortModel: [{ field: "fecha", sort: "desc" }],
                                    },
                                }}
                                slots={{ noRowsOverlay: DiseñoDataGrid }}
                                getRowId={(row) => row.id}
                                sx={{
                                    fontFamily: 'Poppins, sans-serif',
                                    '& .MuiDataGrid-columnHeaders': {
                                        color: '#113e21ff',
                                        fontWeight: 600,
                                        textTransform: 'capitalize',
                                    },
                                    '& .MuiDataGrid-cell': {
                                        textTransform: 'capitalize',
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                )}
            </Paper>

            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert}>
                <Box sx={modalStyle}>
                    <section style={{ textAlign: "center", padding: "1rem" }}>
                        <CircularProgress style={{ color: "#2a8d74" }} />
                        <p className="alert-text">Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <Box sx={{ ...modalStyle, width: 600, padding: 10 }}>
                    <Typography variant="h6" mb={2} sx={Titulo}>
                        Selecciona la fecha de pago
                    </Typography>

                    <TextField
                        fullWidth
                        label="Fecha"
                        name="date"
                        type="date"
                        value={fechaPago}
                        onChange={(e) => setFechaPago(e.target.value)}
                        margin="normal"
                        sx={{ ...inputFecha, width: '100%' }}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <CalendarToday />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        fullWidth
                        label="episodio"
                        name="episodio"
                        type="number"
                        value={episodio}
                        onChange={(e) => setEpisodio(e.target.value)}
                        margin="normal"
                        sx={{ ...inputFecha, width: '100%' }}
                        InputLabelProps={{ shrink: true }}

                    />



                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 5 }}>
                        <Button

                            onClick={() => setDialogOpen(false)}
                            sx={buttonCancelar}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleCambiarPago}
                            sx={buttonGuardar}
                        >
                            Guardar
                        </Button>
                    </Box>
                </Box>
            </Modal>


            <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth maxWidth="sm">
                <DialogTitle sx={Texto}>Editar Ingreso</DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 2, mb: 2 }}>
                        <FormControl fullWidth sx={Input}>
                            <InputLabel id="estado-pago-label">Estado de pago</InputLabel>
                            <Select
                                labelId="estado-pago-label"
                                name="estado_pago"
                                value={selectedIngreso?.estado_pago || ""} // <-- esto debe ser exactamente lo que hay en la BD
                                onChange={(e) =>
                                    setSelectedIngreso({ ...selectedIngreso, estado_pago: e.target.value })
                                }
                                label="Estado de pago"
                            >
                                <MenuItem value="">General</MenuItem>
                                <MenuItem value="PAGADO">Pagado</MenuItem>
                                <MenuItem value="NO PAGO">No Pagado</MenuItem>

                            </Select>
                        </FormControl>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}
                            label="RUT"
                            fullWidth
                            margin="dense"
                            value={selectedIngreso?.rut || ""}
                            onChange={(e) => {
                                const valorFormateado = FormatRut(e.target.value);
                                setSelectedIngreso({ ...selectedIngreso, rut: valorFormateado });
                            }}
                        />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}
                            label="Nombre Paciente"
                            fullWidth
                            margin="dense"
                            value={selectedIngreso?.nombre_paciente || ""}

                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, nombre_paciente: e.target.value })
                            }
                        />
                    </Box>





                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}
                            label="Sesiones"
                            fullWidth
                            margin="dense"
                            value={selectedIngreso?.n_sesiones || ""}

                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, n_sesiones: e.target.value })
                            }
                        />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}
                            label="Episodio"
                            fullWidth
                            margin="dense"
                            value={selectedIngreso?.episodio || ""}

                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, episodio: e.target.value })
                            }
                        />
                    </Box>
                    <Box sx={{ mb: 2 }}>

                        <InputLabel sx={{ marginLeft: 1, mb: 0 }}> Monto</InputLabel>
                        <FormControl sx={Input} fullWidth>
                            <TextField


                                fullWidth
                                margin="dense"
                                value={formatCLP(selectedIngreso?.monto)}
                                onChange={(e) => {
                                    // eliminar todo lo que no sea número
                                    const numericValue = e.target.value.replace(/\D/g, "");

                                    // actualizar monto y valor simultáneamente
                                    setSelectedIngreso({
                                        ...selectedIngreso,
                                        monto: numericValue,
                                        valor: numericValue,
                                    });
                                }}
                            />
                        </FormControl>

                    </Box>

                    {/* Agrega más campos según necesites */}
                </DialogContent>
                <DialogActions>
                    <Button sx={buttonCancelar} onClick={handleCloseEdit}>Cancelar</Button>
                    <Button sx={buttonGuardar} onClick={handleEditarIngreso}>
                        {enviandoAlert ? "Guardando..." : "Guardar"}
                    </Button>

                </DialogActions>
            </Dialog>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
                <DialogTitle sx={{ fontFamily: "Poppins", fontWeight: 600 }}>
                    Seleccionar mes y año
                </DialogTitle>

                <DialogContent dividers sx={{ p: 3 }}>

                    {/* Seleccionar Mes */}
                    <FormControl fullWidth sx={{ ...InputBuscador, mb: 3 }}>
                        <InputLabel>Mes</InputLabel>
                        <Select
                            value={mesSeleccionadodialog}
                            label="Mes"
                            onChange={(e) => setMesSeleccionadodialog(e.target.value)}
                        >
                            <MenuItem value="">Seleccione...</MenuItem>
                            {meses.map((m) => (
                                <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Seleccionar Año */}
                    <FormControl fullWidth sx={InputBuscador}>
                        <InputLabel>Año</InputLabel>
                        <Select
                            value={anioSeleccionadodialog}
                            label="Año"
                            onChange={(e) => setAnioSeleccionadodialog(e.target.value)}
                        >
                            <MenuItem value="">Seleccione...</MenuItem>
                           
                                <MenuItem  value="2025">2025</MenuItem>
                                <MenuItem  value="2025">2026</MenuItem>
                           
                        </Select>
                    </FormControl>

                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button sx={buttonCancelar} onClick={() => setOpenDialog(false)}>Cancelar</Button>

                    <Button
                        sx={{ fontFamily: 'Poppins', textTransform: 'capitalize' }}
                        variant="contained"
                        disabled={!mesSeleccionadodialog || !anioSeleccionadodialog}
                        onClick={() => {
                            fetchGetPrestacionGeneralAnterior({
                                mes: mesSeleccionadodialog,
                                anio: anioSeleccionadodialog
                            });

                            setOpenDialog(false);
                        }}
                    >
                        Ver Reporte
                    </Button>
                </DialogActions>
            </Dialog>



            <Dialog open={openPrestacion} onClose={handleClosePrestacion} fullWidth maxWidth="xl">
                <DialogTitle sx={{ ...Texto, background: '#589473ff', color: '#ffff' }}>Historial Prestación de servicio</DialogTitle>

                <DialogContent>

                    {/* SELECTS */}
                    <Box sx={{ mt: 4, mb: 2, display: "flex", alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: "flex", gap: 2 }}>
                            <TextField
                                label="Mes"
                                select
                                size="small"
                                value={mesSeleccionado}
                                onChange={(e) => setMesSeleccionado(e.target.value)}
                                sx={inputFecha}
                            >
                                {meses.map((m) => (
                                    <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                                ))}
                            </TextField>

                            <TextField
                                label="Año"
                                select
                                size="small"
                                value={anioSeleccionado}
                                onChange={(e) => setAnioSeleccionado(e.target.value)}
                                sx={inputFecha}
                            >
                                {Array.from({ length: 15 }, (_, i) => {
                                    const year = 2020 + i;
                                    return <MenuItem key={year} value={year}>{year}</MenuItem>;
                                })}
                            </TextField>
                            <Box>
                                <TextField
                                    label="Buscar Episodio"
                                    size="small"
                                    value={episodio}
                                    onChange={(e) => setEpisodio(e.target.value)}
                                    sx={inputFecha}
                                    placeholder="Ej: 12345"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon sx={{ color: "#589473", cursor: "pointer" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>

                            <Button variant="contained" sx={buttonGuardar} onClick={handleBuscarPrestacion}>
                                Buscar
                            </Button>
                        </Box>
                        <Box>
                            <Button
                                variant="contained"
                                sx={{
                                    background: "#4f9176ff",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    fontFamily: 'Poppins',
                                    gap: 1,
                                    textTransform: "none",
                                }}
                                onClick={handleDescargarExcel}
                            >
                                <PiMicrosoftExcelLogoBold size={20} />
                                Descargar reporte
                            </Button>

                        </Box>

                    </Box>
                    <Box>
                        {/* SPINNER DE CARGA */}
                        {loadingPrestacion && (
                            <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
                                <CircularProgress />
                            </Box>
                        )}

                        {/* GRID PAGADOS Y NO PAGADOS */}
                        {!loadingPrestacion && (
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, sm: 6 }} >
                                    <Typography sx={{ ...SubTitulodos, mb: 2 }}>Pagados</Typography>
                                    <Box sx={{ height: 600, width: "100%" }}>
                                        <DataGrid
                                            rows={pagadosFiltrados}
                                            columns={columnasPrestacion}

                                            pageSize={10}
                                            rowsPerPageOptions={[10, 25, 50]}
                                            slots={{ noRowsOverlay: DiseñoDataGrid }}
                                            getRowId={(row) => row.id}
                                            sx={{
                                                height: 600,
                                                fontFamily: 'Poppins, sans-serif',
                                                '& .MuiDataGrid-columnHeaders': {
                                                    color: '#113e21ff',
                                                    fontWeight: 600,
                                                    textTransform: 'capitalize',
                                                },
                                                '& .MuiDataGrid-cell': {
                                                    textTransform: 'capitalize',
                                                },
                                            }}
                                        /></Box>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6, height: 500 }}>
                                    <Typography sx={{ ...SubTitulodos, mb: 2 }}>No Pagados</Typography>
                                    <Box sx={{ height: 600, width: "100%" }}>
                                        <DataGrid
                                            rows={noPagadosFiltrados}
                                            columns={columnasPrestacion}
                                            autoHeight
                                            pageSize={10}
                                            rowsPerPageOptions={[10, 25, 50]}
                                            slots={{ noRowsOverlay: DiseñoDataGrid }}
                                            getRowId={(row) => row.id}
                                            sx={{
                                                height: 600,
                                                fontFamily: 'Poppins, sans-serif',
                                                '& .MuiDataGrid-columnHeaders': {
                                                    color: '#113e21ff',
                                                    fontWeight: 600,
                                                    textTransform: 'capitalize',
                                                },
                                                '& .MuiDataGrid-cell': {
                                                    textTransform: 'capitalize',
                                                },
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        )}

                    </Box>
                    {/* GRID PAGADOS Y NO PAGADOS */}


                </DialogContent>

                <DialogActions>
                    <Button sx={buttonCancelar} onClick={handleClosePrestacion}>Cerrar</Button>
                </DialogActions>
            </Dialog>


        </Container>
    )
}